import axios from "axios"

export type MessageType = "apiMessage" | "userMessage"

export interface SourceDoc {
  page_content: string
  metadata: Record<string, any>
}

export type Message = {
  id?: string
  type: MessageType
  message: string
  isStreaming?: boolean
  sourceDocs?: SourceDoc[]
  provider?: Provider
  comment?: string
  thumbUp?: boolean
}

export interface KmCreateRequest {
  question: string
  history: string[]
  model: string
  taxonomy: string
  lang: string
  prompt: string
  temperature: number
  company_id: string
  genre?: string
  realTaxonomyKey?: string
}

export interface Provider {
  company: string
  logo: string
  url: string
}

export interface Product {
  product: string
  product_key: string
  providers: Provider[]
}

export interface Suggestion {
  products: Product[]
}

export interface KmResponse {
  question: string
  chat_history: string[]
  context: { page_content: string; metadata: any }[]
  answer: string
  id: string
  suggestions?: Suggestion[]
}

export const kmCreate = (kmCreateRequest: KmCreateRequest) =>
  axios.post<KmResponse>(`/api/km/gen`, {
    ...kmCreateRequest,
    k_docs: 5,
    max_tokens: 1500,
    translate_output: true
  })

export interface KmAskRequest {
  question: string
  history: string[]
  model: string
  taxonomy: string
  lang: string
  company_id: string
  genre?: string
  realTaxonomyKey?: string
}

export const kmAsk = (kmAskRequest: KmAskRequest) =>
  axios.post<KmResponse>(
    `/api/km/chat`,
    {
      question: kmAskRequest.question,
      history: kmAskRequest.history
    },
    {
      params: {
        model: kmAskRequest.model,
        tax: kmAskRequest.taxonomy,
        lang: kmAskRequest.lang,
        company_id: kmAskRequest.company_id,
        genre: kmAskRequest.genre,
        real_taxonomy_key: kmAskRequest.realTaxonomyKey
      }
    }
  )

export const kmAskBot = (kmAskRequest: KmAskRequest) =>
  axios.post<KmResponse>(
    `/api/km/chat-bot/chat`,
    {
      question: kmAskRequest.question,
      history: kmAskRequest.history
    },
    {
      params: {
        model: kmAskRequest.model,
        lang: kmAskRequest.lang,
        bot_id: kmAskRequest.company_id
      }
    }
  )

export interface SupportedFileType {
  extension: string
  mimeType: string
}

export const getSupportedFileTypes = async (): Promise<SupportedFileType[]> => {
  const response = await axios.get<SupportedFileType[]>("/api/km/supported-types")
  return response.data
}
